import {
    $axios,
    $authUser
} from '@/plugins/axios'
import {
    getUser,
    getConfig,
    logsByA360,
    listLogs,
    docsByLOB,
    getContainers
} from "@/graphql/queries";
import {
    editConfig,
    createDocument,
    updateDocument,
    deleteDocument
} from "@/graphql/mutations"
import {
    onCreateLog
} from "@/graphql/subscriptions"
import {
    Auth,
    API
} from 'aws-amplify'
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js'

const state = {
    user: '',
    state: '',
    confirmed: false,
    mersBranded: false,
    config: '',
    snPhones: [],
    logs: [],
    subscribe: "",
    activeDocuments: [],
    containers: []
}

const getters = {
    isAuthenticated(state) {
        return !!state.user
    },
    poolId(state) {
        return state.user.pool.userPoolId
    },
    userGroup(state) {
        let group = state.user.signInUserSession.idToken.payload['cognito:groups']
        if (!group) return "User"
        else if (group.includes("SystemAdmin")) return "SystemAdmin"
        else if (group.includes("Super")) return "Super"
        else if (group.includes("Admin")) return "Admin"
        else if (group.includes("DeleteUsers")) return "DeleteUsers"
        else return "User"
    },
    adminOrSuper(state) {
        let group = state.user.signInUserSession.idToken.payload['cognito:groups']
        if (!group) return false
        else if (group.includes("Admin") || group.includes("Super") || group.includes("SystemAdmin") || group.includes("DeleteUsers")) return true
        else return false
    }
}

const actions = {
    // async userType({}, user) {
    //     let group = user.signInUserSession.idToken.payload['cognito:groups']
    //     if (!group) return "User"
    //     else if (group.includes("SystemAdmin")) return "SystemAdmin"
    //     else if (group.includes("Super")) return "Super"
    //     else if (group.includes("Admin")) return "Admin"
    //     else return "User"
    // },
    async checkUser({
        commit,
        dispatch
    }) {
        try {
            let user = await Auth.currentAuthenticatedUser();
            commit("setUser", user);
            // let type = await dispatch("userType", user)
            // if (type === "SystemAdmin") {
            //     dispatch("checkConfig")
            // }
            return true
        } catch (error) {}
    },
    async checkUserDetails({
        state,
        commit
    }, userName) {
        const {
            data
        } = await $axios.post(
            "/", {
                query: getUser,
                variables: {
                    username: userName
                }
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        commit("setUser", user)
        // let type = await dispatch("userType", user)
        // if (type === "SystemAdmin") {
        //     dispatch("checkConfig")
        // }
    },
    async checkConfig({
        state,
        commit,
        dispatch
    }) {
        const {
            data: {
                data
            }
        } = await $axios.post(
            "/", {
                query: getConfig
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        commit("setConfig", data.getConfig)
        await dispatch("setupActiveDocuments")
        return data.getConfig
    },
    async setupActiveDocuments({ state, commit, dispatch }) {
        let [documents, containers] = await Promise.all([dispatch("checkDocuments", state.mersBranded ? "MERS" : "Alerus"), dispatch("checkContainers")])
        let docTypes = {}
        containers.forEach(item => docTypes[item.label] = documents.filter(doc => {
            return doc.container === item.name
        }).sort((a,b) => a.order > b.order ? 1 : a.order < b.order ? -1 : 0))
        commit("setActiveDocuments", docTypes)
    },
    async checkDocuments({
        state,
        commit
    }, lob) {
        const {
            data: {
                data
            }
        } = await $axios.post(
            "/", {
                query: docsByLOB,
                variables: {
                    lob
                }
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
            );
        return data.docsByLOB.items
        // commit("setActiveDocuments", data.docsByLOB.items)
    },
    async checkContainers({
        state,
        commit
    }) {
        const {
            data: {
                data
            }
        } = await $axios.post(
            "/", {
                query: getContainers,
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
            );
        commit("setContainers", data.getContainers)
        return data.getContainers
    },
    async checkSecureNowPhones({
        state,
        commit
    }, AffectedUserId) {
        const {
            data
        } = await $authUser.post(`/SecureNow/GetPhones`, {
            AffectedUserId,
            IsMersCsr: state.mersBranded ? true : false
        }, {
            headers: {
                Authorization: `Bearer ${
                state.user.signInUserSession.idToken.jwtToken
              }`
            }
        });
        let phones = JSON.parse(data)["Phones"];
        let allPhones = phones.map(item => {
            item.PhoneNumber = parsePhoneNumberFromString(item.PhoneNumber, {
                defaultCallingCode: item.CountryCode
            }).number
            return item
        })
        commit("setSNPhones", allPhones)
    },
    async removeSecureNowPhone({
        state,
        commit
    }, phone) {
        const {
            data
        } = await $authUser.post(
            `/SecureNow/DeletePhone`, {
                PhoneId: phone.id,
                AffectedUserId: phone.user,
                IsMersCsr: state.mersBranded ? true : false
            }, {
                headers: {
                    Authorization: `Bearer ${
            state.user.signInUserSession.idToken.jwtToken
          }`
                }
            }
        );
        let res = JSON.parse(data).Action
        if (res === "PhoneDeleted") {
            commit("removeSNPhone", phone.id)
            return true
        } else return false
    },
    async addSecureNowPhone({
        state,
        commit
    }, phone) {
        const {
            data
        } = await $authUser.post(
            `/SecureNow/InsertPhone`, {
                Number: phone.full,
                CountryCode: phone.country,
                DefaultChallengeType: "5",
                AffectedUserId: phone.user,
                IsMersCsr: state.mersBranded ? true : false
            }, {
                headers: {
                    Authorization: `Bearer ${
            state.user.signInUserSession.idToken.jwtToken
          }`
                }
            }
        );
        let newPhone = JSON.parse(data)
        if (newPhone.ErrorMessage === "IA: Phone already exists for user") {
            return
        } else {
            let id = JSON.parse(data)["Id"];
            let parsePhone = parsePhoneNumberFromString(phone.full, {
                defaultCallingCode: phone.country
            }).number
            let lastPhone = {
                PhoneID: `${id}`,
                PhoneNumber: parsePhone,
                CountryCode: phone.country
            }
            commit("addSNPhone", lastPhone)
        }
    },
    async getLogs({ state, commit, dispatch }, a360id) {
        const {
            data: {
                data: {
                    logsByA360: {
                        items
                    }
                }
            }
        } = await $axios.post(
            "/", {
                query: logsByA360,
                variables: {
                    a360id,
                    sortDirection: "DESC",
                    limit: 200
                }
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
        )
        commit("setLogs", items)
        dispatch("logSubscribe", a360id)
    },
    async getUserLogs({ state, commit, dispatch }, actionOn) {
        const {
            data: {
                data: {
                    listLogs: {
                        items
                    }
                }
            }
        } = await $axios.post(
            "/", {
                query: listLogs,
                variables: {
                    actionOn,
                    sortDirection: "DESC",
                    limit: 200
                }
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
        )
        commit("setLogs", items)
        dispatch("logSubscribe", actionOn)
    },
    async updateConfig({
        state,
        commit
    }, {message, maintenance, docTypes}) {
        const {
            data: {
                data
            }
        } = await $axios.post(
            "/", {
                query: editConfig,
                variables: {
                    message,
                    maintenance,
                    docTypes
                }
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        let res = false
        if (message === data.editConfig.message) res = true
        else if (maintenance === data.editConfig.maintenance) res = true
        else if (docTypes.length === data.editConfig.docTypes.length) res = true
        if (res) commit("setConfig", data.editConfig)
        return {
            res,
            newConfig: data.editConfig
        }
    },
    async createActiveDocument({
        state,
        commit
    }, { documentId, name, filterType, container, lob, list, order }) {
        try {
            const {
                data: {
                    data
                }
            } = await $axios.post(
                "/", {
                query: createDocument,
                variables: {
                    input: {
                        documentId,
                        name,
                        filterType,
                        container,
                        lob,
                        order
                    }
                }
            },{
                headers: {
                        Authorization: state.user.signInUserSession.idToken.jwtToken
                    }
                }
                );
            if (data.createDocument) {
                commit("addActiveDocument", {
                    list,
                    item: data.createDocument
                })
                return true
            } 
            else return false
        } catch (error) {
            console.log("error creating document", error)
            return false
        }
    },
    async updateActiveDocument({
        state,
        commit
    }, { id, order }) {
        try {
            const {
                data: {
                    data
                }
            } = await $axios.post(
                "/", {
                query: updateDocument,
                variables: {
                    input: {
                        id,
                        order
                    }
                }
            },{
                headers: {
                        Authorization: state.user.signInUserSession.idToken.jwtToken
                    }
                }
                );
            if (data.updateDocument) {
                // commit("addActiveDocument", {
                //     list,
                //     item: data.createDocument
                // })
                return true
            } 
            else return false
        } catch (error) {
            console.log("error creating document", error)
            return false
        }
    },
    async deleteActiveDocument({
        state,
        commit
    }, id) {
        try {
            const {
                data: {
                    data
                }
            } = await $axios.post(
                "/", {
                query: deleteDocument,
                variables: {
                    input: {
                        id
                    }
                }
            },{
                headers: {
                        Authorization: state.user.signInUserSession.idToken.jwtToken
                    }
                }
                );
            if (data.deleteDocument) return true
            else return false
        } catch (error) {
            console.log("error deleting document", error)
            return false
        }
    },
    hostedUILink() {
        const config = Auth.configure();
        const {
            domain,
            redirectSignIn,
            responseType
        } = config.oauth;
        return `https://${domain}/login?redirect_uri=${redirectSignIn}&response_type=${responseType}&client_id=${
          config.userPoolWebClientId}`;
    },
    logSubscribe({ commit }, val) {
        let sub = API.graphql({
            query: onCreateLog
        }).subscribe({
            next: logData => {
                let {
                    value: {
                        data: {
                            onCreateLog
                        }
                    }
                } = logData;
                if (onCreateLog.a360id === val || onCreateLog.actionOn === val) {
                    commit("addLog", onCreateLog)
                }
            }
        });
        commit("setSubscribe", sub)
    },
    logUnsubscribe({
        commit,
        state
    }) {
        state.subscribe.unsubscribe()
        commit("removeSubscribe")
    },
    async login({
        dispatch
    }) {
        let login = await dispatch("hostedUILink")
        window.location.href = login
        // window.location.replace(await dispatch("hostedUILink"));
    },
    async sendDetails({
        state
    }) {
        const {
            data
        } = await $axios.post(
            "/", {
                query: getUserInfo,
                variables: {
                    ssn: this.extraInfo.ssn
                }
            }, {
                headers: {
                    Authorization: this.user.signInUserSession.idToken.jwtToken
                }
            }
        );

    }
}

const mutations = {
    setUser(state, user) {
        state.user = user
    },
    setConfig(state, config) {
        state.config = config
    },
    setUserGroup(state, group) {
        state.userGroup = group
    },
    setUserAtts(state, atts) {
        state.user.attributes = atts
    },
    setState(state, authState) {
        state.state = authState
    },
    setConfirmed(state) {
        state.confirmed = true
    },
    emptyUser(state) {
        state.user = ""
    },
    unsetConfirmed(state) {
        state.confirmed = false
    },
    setMERSBranded(state, bool) {
        state.mersBranded = bool;
    },
    setSNPhones(state, phones) {
        state.snPhones = phones
    },
    addSNPhone(state, phone) {
        state.snPhones.push(phone)
    },
    removeSNPhone(state, phone) {
        let id = state.snPhones.findIndex(item => item.PhoneID === phone)
        state.snPhones.splice(id, 1)
    },
    addActiveDocument(state, doc) {
        let id = state.activeDocuments[doc.list].findIndex(item => item.id === doc.id)
        state.activeDocuments[doc.list].splice(id, 1, doc.item)
    },
    removeActiveDocument(state, doc) {
        let id = state.activeDocuments[doc.list].findIndex(item => item.id === doc.id)
        state.activeDocuments[doc.list].splice(id, 1)
    },
    setLogs(state, logs) {
        state.logs = logs
    },
    emptyLogs(state) {
        state.logs = []
    },
    addLog(state, log) {
        state.logs.push(log)
    },
    setSubscribe(state, subscribe) {
        state.subscribe = subscribe
    },
    removeSubscribe(state, sub) {
        state.subscribe = ""
    },
    setActiveDocuments(state, docs) {
        state.activeDocuments = docs
    },
    setContainers(state, containers) {
        state.containers = containers
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}